import { useQuery } from '@tanstack/react-query';

import { getSearchPaymentMethodSelectOptions } from './paymentMethods';
import { TypesenseCollection } from '../types';
import { useGetTypeSenseAPIKeys } from '@/api/REST/typeSenseAPIKeys';
import { ExpenseFormType } from '@/pages/register/expenses/types';

const DEFAULT_PAYMENT_METHOD_OPTION_KEY = 'defaultPaymentMethodOption';
export const useGetDefaultPaymentMethodOption = (
  expenseFormType: ExpenseFormType,
) => {
  const { data: apiKeys } = useGetTypeSenseAPIKeys();

  const collectionApiKey =
    apiKeys?.[TypesenseCollection.PAYMENT_METHODS.keyName]?.key ?? null;

  const defaultFilter =
    expenseFormType === 'personal'
      ? 'IsDefaultForEmployeeExpense:true'
      : 'IsDefaultForProjectExpense:true';

  const { data, ...restProps } = useQuery({
    queryKey: [
      DEFAULT_PAYMENT_METHOD_OPTION_KEY,
      defaultFilter,
      collectionApiKey,
    ],
    queryFn: () =>
      getSearchPaymentMethodSelectOptions('*', collectionApiKey!, 1, {
        filterBy: defaultFilter,
      }),
    enabled: !!expenseFormType && !!collectionApiKey,
  });

  if (data?.length && data.length > 1) {
    console.warn(
      `More than one default payment method found for expenseFormType: ${expenseFormType}. Using the first one.`,
    );
  }

  return { data: data ? data[0] : undefined, ...restProps };
};
